import { api as generatedApi } from 'gen/rtk-openapi'

const TAG_TYPES = {
  purchaseOrders: 'PurchaseOrders',
  inboundTickets: 'InboundTickets',
}

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [TAG_TYPES.purchaseOrders],
  endpoints: {
    getPurchaseOrders: {
      providesTags: result =>
        result && result.length > 0
          ? // successful query
            [
              ...result.map(purchaseOrder => ({
                type: TAG_TYPES.purchaseOrders,
                id: purchaseOrder.id,
              })),
              { type: TAG_TYPES.purchaseOrders, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'PurchaseOrders', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.purchaseOrders, id: 'LIST' }],
    },
    getPurchaseOrdersV2: {
      providesTags: result =>
        result && result.length > 0
          ? // successful query
            [
              ...result.map(purchaseOrder => ({
                type: TAG_TYPES.purchaseOrders,
                id: purchaseOrder.id,
              })),
              { type: TAG_TYPES.purchaseOrders, id: 'LIST' },
            ]
          : // error occurred, refetch when `{ type: 'PurchaseOrders', id: 'LIST' }` is invalidated
            [{ type: TAG_TYPES.purchaseOrders, id: 'LIST' }],
    },
    getPurchaseOrder: {
      providesTags: (result, error, { purchaseOrderId }) => [{ type: TAG_TYPES.purchaseOrders, id: purchaseOrderId }],
    },
    createPurchaseOrder: {
      invalidatesTags: [{ type: TAG_TYPES.purchaseOrders, id: 'LIST' }],
    },
    updatePurchaseOrder: {
      invalidatesTags: (result, error, { purchaseOrderId }) => {
        return [
          { type: TAG_TYPES.purchaseOrders, id: purchaseOrderId },
          { type: TAG_TYPES.inboundTickets, id: purchaseOrderId },
        ]
      },
    },
    archivePurchaseOrder: {
      invalidatesTags: (result, error, { purchaseOrderId }) => [
        { type: TAG_TYPES.purchaseOrders, id: purchaseOrderId },
        { type: TAG_TYPES.purchaseOrders, id: 'LIST' },
      ],
    },
    getPurchaseOrdersCsv: {},
    uploadPurchaseOrdersCsv: {
      invalidatesTags: () => [{ type: TAG_TYPES.purchaseOrders }],
    },
  },
})

export const useGetPurchaseOrdersCsvLazyQuery = api.endpoints.getPurchaseOrdersCsv.useLazyQuery

export const {
  useGetPurchaseOrdersQuery,
  useGetPurchaseOrdersV2Query,
  useGetPurchaseOrderQuery,
  useCreatePurchaseOrderMutation,
  useUpdatePurchaseOrderMutation,
  useArchivePurchaseOrderMutation,
  useUploadPurchaseOrdersCsvMutation,
} = api
